import React from 'react'
import { useDispatch } from 'react-redux'
import useStyles from './styles'
import {
  Box,
  Typography,
  IconButton,
  Icon,
  Button,
  ClickAwayListener
} from '@material-ui/core'
import useNameStyle from 'hooks/useNameStyle'
import useIsManager from 'hooks/useIsManager'
import { openConfirmDialog } from 'actions/confirm-dialog'
import { removeMessageLocal, deleteMessage } from 'actions/event'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'clsx'

const Chat = ({ data }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const isManager = useIsManager()

  const event = useSelector(state => state.event.event)

  const handleDelete = () => {
    dispatch(
      openConfirmDialog({
        text: 'Are you sure you want to delete this message?'
      })
    ).then(() => {
      dispatch(deleteMessage(data.id, event.auction_code)).then(() => {
        dispatch(removeMessageLocal(data.id))
      })
    })
  }

  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )

  const mine = useMemo(() => {
    return data.user_id === authenticatedUser.user_id
  }, [data.user_id, authenticatedUser.user_id])

  return (
    <Box
      className={classnames(classes.chat, {
        [classes.chatMine]: mine,
        [classes.withDeleteButton]: isManager
      })}
    >
      <Typography className={classes.chatTypography}>
        <span>{data.name}:</span> {data.body}
        {isManager && (
          <IconButton
            onClick={handleDelete}
            size="small"
            className={classes.button}
          >
            <Icon small>delete</Icon>
          </IconButton>
        )}
      </Typography>
    </Box>
  )
}

export default Chat



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatList/Chat/index.jsx